export default "__VITE_ASSET__B_tNG0E3__"